import { render, staticRenderFns } from "./PayInfo.vue?vue&type=template&id=367b2e72&"
import script from "./PayInfo.vue?vue&type=script&lang=js&"
export * from "./PayInfo.vue?vue&type=script&lang=js&"
import style0 from "./PayInfo.vue?vue&type=style&index=0&id=367b2e72&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports